/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_SuccessInputs */



/**
* | output |
* | --- |
* | "Event text and metadata copied successfully" |
*
* @param {Copy_Event_Text_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_success = /** @type {((inputs?: Copy_Event_Text_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Texte et métadonnées de l'événement copiés avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext und Metadaten erfolgreich kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Testo e metadati dell'evento copiati con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст и метаданные события успешно скопированы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Texto y metadatos del evento copiados correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件文本和元数据复制成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストとメタデータをコピーしました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट और मेटाडेटा सफलतापूर्वक कॉपी किए गए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Texto e metadados do evento copiados com sucesso")
	return /** @type {LocalizedString} */ ("Event text and metadata copied successfully")
});